import script from "./ClubHighlightEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightEdit.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightEdit.vue?vue&type=style&index=0&id=80726682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80726682"]])

export default __exports__